<script setup>
defineProps({ title: { type: String, required: true }, text: { type: String, default: '' }, icon: { type: String, default: 'inbox' } })
</script>
<template>
  <div class="rounded-app-card border border-dashed border-slate-300 bg-white px-6 py-10 text-center">
    <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-app-control bg-slate-100 text-slate-500">
      <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16v14H4z"/><path d="m4 13 4-4 4 4 4-4 4 4"/></svg>
    </div>
    <h3 class="mt-4 text-base font-black text-app-text">{{ title }}</h3>
    <p v-if="text" class="mx-auto mt-1 max-w-md text-sm font-semibold leading-6 text-app-muted">{{ text }}</p>
    <div v-if="$slots.default" class="mt-5 flex justify-center"><slot /></div>
  </div>
</template>
